import type { EditorCommand } from '@atlaskit/editor-common/types';

import type {
	AllowedAIEvents,
	CompleteAIEvent,
	StreamAIEvent,
	ErrorAIEvent,
} from '../../editor-actions/types';

import { createCommand } from './ai-session-context-plugin';

export const resetSessionState = (): EditorCommand => createCommand({ type: 'RESET' });

export const streamADFResponse = ({ adfResponse }: StreamAIEvent): EditorCommand =>
	createCommand({ type: 'STREAM', adfResponse });
export const completeADFStream = ({ adfResponse }: CompleteAIEvent): EditorCommand =>
	createCommand({ type: 'COMPLETE', adfResponse });
export const errorADFStream = ({ errorInfo }: ErrorAIEvent): EditorCommand =>
	createCommand({ type: 'ERROR', errorInfo });

// ==== Only used for prompts using the internal streaming infrastructure ====
// These can be deleted when all prompts are migrated to use the orchestrator.
export const updateTraceIds = (traceIds: string[]): EditorCommand =>
	createCommand({ type: 'UPDATE_TRACE_IDS', traceIds });
export const cancelStream = (): EditorCommand => createCommand({ type: 'CANCEL_STREAM' });
export const pauseStream = (): EditorCommand => createCommand({ type: 'PAUSE_STREAM' });
export const resumeStream = (): EditorCommand => createCommand({ type: 'RESUME_STREAM' });
/**
 * Dispatches an allowed AI event by converting it to the appropriate command.
 * Only 'stream', 'complete', and 'error' events are supported. These events are
 * dispatched by the AI streaming orchestrator.
 *
 * @param event - The AI event to dispatch
 * @returns The corresponding EditorCommand, or undefined if the event type is not supported
 */
export const dispatchAllowedStreamingEvent = (
	event: AllowedAIEvents,
): EditorCommand | undefined => {
	switch (event.type) {
		case 'stream':
			return streamADFResponse(event);
		case 'complete':
			return completeADFStream(event);
		case 'error':
			return errorADFStream(event);
		default: {
			assertUnreachable(event);
			return undefined;
		}
	}
};

function assertUnreachable(_x: never) {}
